import React from 'react';
import PropTypes from 'prop-types';

const Covid19Tickbox = (props) => {
  const { id, name, label, input, meta, handleChange } = props;
  return (
    <div className="covid-19-tickbox form-checkbox-container">
      <span className="relative">
        <input
          id={id}
          className="form-checkbox-input"
          type="checkbox"
          name={name}
          {...input}
          checked={input.value}
          onChange={(e) => { handleChange(e); input.onChange(e); }}
        />
        <label
          className={`form-checkbox-label autotest-${id}`}
          htmlFor={id}
        >{label}</label>
      </span>
      {meta && meta.touched && meta.error &&
      <div className="form-validation-message">{meta.error}</div>
      }
    </div>
  );
};

Covid19Tickbox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  handleChange: PropTypes.func
};

Covid19Tickbox.defaultProps = {
  handleChange: () => {}
};

export default Covid19Tickbox;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/PreferredConnectionDate/Covid19Tickbox.js
 **/